import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { translations } from "./translations";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ApexTeam from "./components/ApexTeam";
import Services from "./components/Services";
import Differentials from "./components/Differentials";
import PredimedInvite from "./components/PredimedInvite";
import Footer from "./components/Footer";
import BackgroundMusic from "./components/BackgroundMusic";
import BusinessArea from "./components/BusinessArea";
import NetworkSimulator from "./components/NetworkSimulator";
import Primes from "./components/Primes";
import Projectos from "./components/Projectos";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/toaster";

function App() {
  const [language, setLanguage] = useState('pt');
  const t = translations[language];

  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route 
            path="/business" 
            element={
              <ProtectedRoute>
                <BusinessArea />
              </ProtectedRoute>
            } 
          />
          <Route path="/simulador" element={<NetworkSimulator language={language} />} />
          <Route path="/primes" element={<Primes />} />
          <Route path="/projectos" element={<Projectos />} />
          <Route path="/" element={
            <>
              <Navbar t={t} language={language} setLanguage={setLanguage} />
              <Hero t={t} />
              <ApexTeam t={t} language={language} />
              <Services t={t} />
              <Differentials t={t} />
              <PredimedInvite t={t} />
              <Footer t={t} />
              <BackgroundMusic />
            </>
          } />
        </Routes>
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;
